import inview from 'jquery-inview';
import {TweenMax, TimelineLite} from "gsap";

module.exports = function(str) {
	const addclass = {className:"+=active"};

	const TL = new TimelineMax();
	$('.home_works .works_img_wrapper').on('inview',function(event, isInView, visiblePartX, visiblePartY){
		TL
		.to('.js-animate_007 .js-img-box', .3, addclass)
		.to('.js-animate_008 .js-img-box', .3, addclass)
		.to('.js-animate_009 .js-img-box', .3, addclass)
		.to('.js-animate_010 .js-img-box', .3, addclass)
		.to('.js-animate_011 .js-img-box', .3, addclass)
		.to('.js-animate_012 .js-img-box', .3, addclass);
	});
}



// WEBPACK FOOTER //
// ./dev/js/scripts/imgbox_animation.js